import { makeStyles } from '@material-ui/core/styles'
import themesConfig from 'app/fuse-configs/themesConfig'

export default makeStyles({
  root: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '& .MuiSvgIcon-root': {
      fill: themesConfig.default.colors.primary,
    },
  },
  formControlLabel: {
    marginTop: 13,
    marginRight: 0,
    color: themesConfig.default.colors['neutrals-800'],
  },
})
